import { AppRegistry } from 'react-native';
import AppWithSuspenseBoundary, {
    AppProps,
} from '@indeed/jobsearch-react-native-bundle/viewjob/src/App';
import { NavigationType } from '@indeed/jobsearch-react-native-bundle/shared/util/NavigationType';
import withProviderTracking from '@indeed/jobsearch-react-native-bundle/shared/components/ProviderRoot/ProviderRoot';
import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

// SafeAreaProvider must wrap the app on web standalone so that SafeAreaProviderCompat
// inside NativeStackView (react-native-screens) finds existing insets context and renders
// its container with flex:1. Without it, NativeSafeAreaProvider.web renders a View with
// no style, collapsing the height chain and preventing StickyButtonsRoot's ScrollView
// from getting a bounded height — nothing can scroll.
//
// initialMetrics must be provided so that SafeAreaProvider's initial insets state is a
// truthy object (not null). If null, SafeAreaProviderCompat takes the unstyled code path
// on first render and the height chain is broken until an async re-render.
const INITIAL_SAFE_AREA_METRICS = {
    frame: { x: 0, y: 0, width: 0, height: 0 },
    insets: { top: 0, left: 0, right: 0, bottom: 0 },
};

function AppWithSafeArea(props: AppProps) {
    return React.createElement(SafeAreaProvider, { initialMetrics: INITIAL_SAFE_AREA_METRICS },
        React.createElement(AppWithSuspenseBoundary, props),
    );
}

AppRegistry.registerComponent('main', () =>
    withProviderTracking(AppWithSafeArea, 'ViewJob'),
);

const rootTag = document.getElementById('root');
if (process.env.NODE_ENV !== 'production') {
    if (!rootTag) {
        throw new Error('Required HTML element with id "root" was not found in the document HTML.');
    }
}

try {
    AppRegistry.runApplication('main', {
        rootTag,
        hydrate: globalThis._initialData?.ssr ?? false,
        initialProps: {
            ...globalThis._rootProps,
            navigationType: NavigationType.PUSH_AS_FIRST,
            preloadedVJData:
                globalThis._rootProps?.preloadedVJData ??
                globalThis._initialData?.viewJobClientSideModel,
        } satisfies AppProps,
    });
} catch (e: unknown) {
    // @ts-ignore
    globalThis._latestError = e;
}
